<template>
  <div
    class="key-value"
    :class="{'line': line}">
    <div
      class="key-value__label"
      :data-qa="`${dataQa}_key`">
      {{ caption }}
      <slot name="captionAfter"/>
    </div>
    <div
      class="key-key"
      :data-qa="`${dataQa}_value`">
      <template v-if="!hasValueSlot">
        {{ value }}
      </template>
      <template v-else>
        <slot/>
      </template>
    </div>
  </div>
</template>
<script>
/**
* Отображение данных в формате ключ - значение
* @category components
* @vue-prop {String} caption - Описание
* @vue-prop {String} value - Значение
* @vue-computed {Boolean} hasValueSlot - Присутсвуют данные в слоте
*/
export default {
  name: 'KeyValue',
  computed: {
    hasValueSlot() {
      return !!this.$slots.default
    },
  },
  props: {
    caption: {
      type: String
    },
    value: {
      type: [String, Number]
    },
    dataQa: {
      type: String,
      default: 'key-value'
    },
    line: {
      type: Boolean
    }
  }
}
</script>
<style scoped lang="scss">
.key-value {
  text-align: start;
  &.line {
    flex-wrap: nowrap;
    display: flex;

    .key-value__label {
      margin: auto 10px auto 0;
    }
    .key-value__key {
      margin: auto 0;
    }
  }
  &__label {
    white-space: normal;
    max-width: 100%;
    margin-bottom: 4px;
    color: var(--v-secondary__green_not_active-base);
    text-transform: uppercase;
    opacity: 0.8;
    font-weight: 500;
    font-size: 11px;
    line-height: 14px;
    letter-spacing: 0.02em;
  }
  &__key {
    white-space: normal;
    max-width: 100%;
    font-size: 14px !important;
    font-weight: 400 !important;
    line-height: 18px !important;
  }
}
</style>
